import dayjs from 'dayjs';
import { ReactComponent as GoogleIcon } from '../../../assets/svg/badgets/google.svg';
import { ReactComponent as WebIcon } from '../../../assets/svg/badgets/web.svg';
import { ReactComponent as NewClientIcon } from '../../../assets/svg/badgets/new_client.svg';
import { ReactComponent as BirthdayIcon } from '../../../assets/svg/badgets/birthday.svg';
import { ReactComponent as SalonIcon } from '../../../assets/svg/badgets/barber_pole.svg';
import { ReactComponent as PaidIcon } from '../../../assets/svg/badgets/paid.svg';
import { ReactComponent as NoteIcon } from '../../../assets/svg/badgets/note.svg';
import { ReactComponent as RecurrenceIcon } from '../../../assets/svg/badgets/recurrence.svg';
import { ReactComponent as ExploreTaglioIcon } from '../../../assets/svg/icons/scissors_blue.svg';
import i18next from 'i18next';
import { ReactComponent as CashIcon } from '../../../assets/svg/icons/coin_black.svg';
import { ReactComponent as CardIcon } from '../../../assets/svg/icons/credit_card_black.svg';
import AppPrivataIcon from 'Containers/Common/AppPrivataIcon';

export const badgetList = {
  1: {
    icon: <PaidIcon />,
    text: i18next.t('scheduler.badges.paid'),
  },
  2: {
    icon: <NewClientIcon />,
    text: i18next.t('scheduler.badges.newClient'),
  },
  3: {
    icon: <BirthdayIcon />,
    text: i18next.t('scheduler.badges.birthday'),
  },
  4: {
    icon: <GoogleIcon />,
    text: i18next.t('scheduler.badges.fromGoogle'),
  },
  5: {
    icon: <WebIcon />,
    text: i18next.t('scheduler.badges.fromWeb'),
  },
  6: {
    icon: <RecurrenceIcon />,
    text: i18next.t('scheduler.badges.recurring'),
  },
  7: {
    icon: <SalonIcon />,
    text: i18next.t('scheduler.badges.fromSalon'),
  },
  8: {
    icon: <NoteIcon />,
    text: i18next.t('scheduler.badges.note'),
  },
  9: {
    icon: <AppPrivataIcon />,
    text: i18next.t('scheduler.badges.fromPrivateApp'),
  },
  10: {
    icon: <ExploreTaglioIcon width="16px" height="16px" />,
    text: i18next.t('scheduler.badges.fromExplore'),
  },
};

export const selectBadges = (task) => {
  const currentDay = dayjs();
  const taskDay = dayjs(task.data_prenotazione);

  return {
    1: task.statusPayment === 2,
    2: !!task.isFirstTime,
    3:
      task.birthday &&
      (taskDay.format('MM-DD') == dayjs(task.birthday).format('MM-DD') ||
        taskDay.format('MM-DD') == dayjs(task.birthday).subtract(1, 'day').format('MM-DD')),
    4: !!task.isFromGoogle,
    5: !!task.web && !task.isFromPrivateApp,
    6: !!task?.ricorrente,
    7: !!task.self_prenotatione,
    8: !!task.nota,
    9: !!task.isFromPrivateApp,
    10: !!(task.idTaglio ?? task.idtaglio),
  };
};

export const noPriceSalons = [67,79,197,240,493,587,586,611,653,669,691,772,109];

export const paymentMethodList = [
  {
    icon: <CashIcon width='20px' height='20px' />,
    // Tradotto nel componente: a module-load i18next non è ancora inizializzato.
    labelKey: 'scheduler.taskInfoModal.cashTag',
    value: 0,
  },
  {
    icon: <CardIcon width='20px' height='20px' />,
    labelKey: 'scheduler.taskInfoModal.cardTag',
    value: 1,
  },
];

